import React, { Component } from 'react';
import { Link } from 'react-router';
import { Grid } from 'react-bootstrap';
import logo from '../assets/logo.svg';

export default class Auth extends Component {
  render() {
    const wide =
      this.props.location.pathname === '/signup' ||
      this.props.params.key === 'ref';

    return (
      <div className="auth-container">
        <Grid className={`${wide && 'wide'}`}>
          <div className="site-logo">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>

          {this.props.children}
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/Auth.jsx